import {bindActionCreators} from 'redux';
import store from '../store.js'
import General from '../helpers/General.js';
import GeneralModule from '../modules/General.js';
import axios from 'axios';
import BrowserNotifications from '../components/BrowserNotification.js';
import {addCarts,chatSetGlobalKey,addPages,setVisitorKey,addMessage,setAssignee,setInit,removeVisitor,addVisitorData,updateVisitor,addVisitor,addVisitors,switchChatStatus} from '../actions/Chat.js';
import {setConnectionStatus} from '../actions/Login.js';
import {updateSegment} from '../actions/Segment.js';
import {setGlobalKey,setOpenConversation,setUnreadMessages} from '../actions/General.js';
import {hashHistory} from 'react-router';
import io from "socket.io-client";
import Helper from "../../../lib/helpers/index";

class SocketManager {
    constructor() {
        this.ws = false;

        if(typeof localStorage.isOnline === 'undefined') {
            localStorage.setItem('isOnline',false);
        }
        this.hasStarted = false;

    }

    loadStaticVisitorList() {
        axios.get('/dashboard').then((data) => {

            let res = {};
            let cart = {};
            let pages = {};
            let conversations = data.data.conversations;

            let s = store.getState();

            data.data.visitors.map(visitor => {

                Object.keys(visitor).map(i => {
                    visitor[i] = General.parseValue(visitor[i]);
                });


                cart[visitor.uid] = JSON.parse(visitor.cart);
                pages[visitor.uid] = JSON.parse(visitor.pages);
                delete visitor.cart;
                res[visitor.uid] = visitor;

            });
            store.dispatch(chatSetGlobalKey('conversations',conversations));
            store.dispatch(addVisitors(res));
            store.dispatch(addCarts(cart));
            store.dispatch(addPages(pages));
            store.dispatch(setInit(true));

        });
    }

    isOnline() {
        return store.getState().chat.isOnline;
    }

    setOnlineStatus(status) {
        if(typeof status === 'object') {
            status = status.payload;
        }
        store.dispatch(switchChatStatus(status));
    }



    segmentComplete(data) {
        let state = store.getState();

        state.segments.list.map((item,i) => {
            if(item.id == data.payload.id) {
                store.dispatch(updateSegment(i,data.payload));
            }
        });

        //



        //store.dis
    }

    getOnlineStatus() {
        let status = localStorage.isOnline;
        if(status == 'true') {
            status = true;
        }

        if(status == 'false') {
            status = false;
        }

        return status;
    }

    canStartConnection() {
        if(store.getState().auth.token !== '' && store.getState().auth.currentAccount !== false) {
            return true;
        }

        return false;
    }


    isTyping(data) {
        store.dispatch(setVisitorKey(data.payload.uid,'isTyping',data.payload.status));
    }

    offline(data) {
        store.dispatch(setVisitorKey(data.payload,'online',0));
    }

    hasConnection() {
        return this.ws.connected;
    }

    closeConversation(data) {
        let state = store.getState();

        if(state.chat.visitors[data.payload]) {

            if(state.chat.visitors[data.payload] === false) {
                store.dispatch(removeVisitor(data.payload));
            }else{
                store.dispatch(setAssignee(0,data.payload));
            }
        }
    }

    view(data) {
        Object.keys(data.payload).map(i => {
            data.payload[i] = General.parseValue(data.payload[i]);
        });
        store.dispatch(addVisitor(data.payload));
    }

    visitorList(data) {
        let res = {};
        let cart = {};
        let s = store.getState();

        data.payload.map(visitor => {
            if(typeof s.chat.visitors[visitor.info.uid] === 'undefined') {
                res[visitor.info.uid] = visitor.info;
                cart[visitor.info.uid] = JSON.parse(visitor.cart);
            }
        });

        store.dispatch(addVisitors(res));
        store.dispatch(addCarts(cart));
        store.dispatch(setInit(true));
    }


    

    onDisconnect() {
        if(store.getState().auth.hadConnection === true && store.getState().auth.wsStatus === true) {
            store.dispatch(setConnectionStatus(false));
        }
    }

    onConnected() {
        if(store.getState().auth.hadConnection === true && store.getState().auth.wsStatus === false) {
            store.dispatch(setConnectionStatus(true));
        }
    }

    onReady() {
//		this.setOnline(this.getOnlineStatus());
        this.ws.send('getVisitorList');
    }

    isDisconnected() {
        return this.ws.disconnected && this.hasStarted;
    }
    

    // NEW

    visitor(data) {
        let subscribers = [];
        let messages = data.messages
        let pages = data.pages
        let cart = data.cart

        if(!messages) {
            messages = [];
        }

        if(!pages) {
            pages = [];
        }else{
            pages = JSON.parse(pages);
        }

        if(!cart) {
            cart = [];
        }else{
            cart = JSON.parse(cart);
        }

        if(data.subscribers) {
            subscribers = data.payload.subscribers;
        }

        store.dispatch(addVisitorData('pages',data.uid,pages));
        store.dispatch(addVisitorData('cart',data.uid,cart));

        delete data.pages;
        delete data.cart;

        Object.keys(data).map(i => {
            data[i] = General.parseValue(data[i]);
        });

        store.dispatch(addVisitor(data));

    }

    setOnline(status) {
        let state = store.getState();
        localStorage.setItem('isOnline',status);
        store.dispatch(switchChatStatus(status))
        this.ws.emit('isOnline',status);
    }

    setClientOnlineStatus(payload) {
        store.dispatch(setVisitorKey(payload.uid,'online',payload.status));
    }

    leave(data) {
        store.dispatch(removeVisitor(data));
    }

    read(uid) {
        store.dispatch(setVisitorKey(uid,'unreadMessages',0));
        this.ws.emit('read',uid);
    }

    setAssignee(user_id,uid) {
        this.ws.emit('setAssignee',{
            user_id:user_id,
            uid:uid,
            s:store.getState().auth.user.id,
        })
    }

    assign(data) {
        store.dispatch(setAssignee(data.user_id,data.uid));
    }

    newMessage(data) {
        let s = store.getState();

        if(!s.chat.visitors[data.uid]) {
            return;
        }

        store.dispatch(addMessage(data.uid,JSON.stringify(data)));
        store.dispatch(setVisitorKey(data.uid,'isTyping',0));
        store.dispatch(setVisitorKey(data.uid,'online',1));

        if(s.chat.visitors[data.uid].assignee_id != s.auth.user.id && s.chat.visitors[data.uid].assignee_id != 0) {
            return;
        }

        if(parseInt(data.from) == 0 && this.getOnlineStatus()) {
            BrowserNotifications.new({
                'title':'New chat message',
                'message':data.text,
                'sound':true,
                'link':GeneralModule.Link('/chat/'+s.auth.user.id+'/'+data.uid)
            });
        }

    }

    clientIsTyping(payload) {
        store.dispatch(setVisitorKey(payload.uid,'online',1));
        store.dispatch(setVisitorKey(payload.uid,'isTyping',parseInt(payload.status)));
    }

    operatorIsTyping(uid,user_id,status) {
        this.ws.emit('operatorIsTyping',{
            uid,user_id,status
        });
    }

    closeConversation(uid) {
        this.ws.emit('closeConversation',uid);
    }

    sendMessage(message) {
        store.dispatch(setVisitorKey(message.uid,'unreadMessages',0));
        store.dispatch(addMessage(message.uid,JSON.stringify(message)));
        this.ws.emit('messageFromOperator',message);
    }

    start() {

        if(this.hasConnection()) {
            return false;
        }

        if(!this.canStartConnection()) {
            return false;
        }

        if(this.hasStarted == true) {
            return;
        }

        this.hasStarted = true;

        this.ws = io(Helper.url().ws, {
            transports: ['websocket'],
        });

        

        this.ws.on('connect', () => {

            let current_state = {
                ...store.getState().auth
            }
    
            this.ws.emit('newOperator', {
                token:current_state.token,
                account:current_state.currentAccount,
                email:current_state.user.email,
                image:current_state.user.image,
                firstname:current_state.user.firstname,
                lastname:current_state.user.lastname,
                isOnline:localStorage.isOnline
            });
        });

        this.ws.on('disconnect', () => {
            console.dir('disconnect');
        });

        this.ws.on('clientIsTyping', (payload) => {
            this.clientIsTyping(payload);
        });
        

        this.ws.on('setClientOnlineStatus', (payload) => {
            this.setClientOnlineStatus(payload)
        });

        this.ws.on('messageFromClient', (payload) => {
            this.newMessage(payload)
        });
        
        this.ws.on('messageFromOperator', (payload) => {
            this.newMessage(payload)
        });

        this.ws.on('setAssignee', (payload) => {
            this.assign(payload)
        });

        this.ws.on('clientDisconnect', (uid) => {
            this.leave(uid);
        });

        this.ws.on('reconnect', () => {
            this.loadStaticVisitorList();
        });

        this.ws.on('view', (data) => {
            this.visitor(data);
        });

        this.ws.on('ready', (status) => {
            store.dispatch(setConnectionStatus(true));

            if(this.getOnlineStatus() == true && status == false) {
                store.dispatch(setGlobalKey('showChatReconnection',true));
            }

            store.dispatch(switchChatStatus(status));

            
        });
    }
}

export default new SocketManager();



// WEBPACK FOOTER //
// ./modules/SocketManager.js